import { create } from "zustand"

export type SketchJobResultOpen = {
  projectId: number
  /** sketch_edit job — host fetches result via API. */
  editId?: number
  /** Direct image URL (e.g. location_scene_face) — skip fetch. Prefer original / proxy. */
  sourceUrl?: string
  downloadUrl?: string
  fileName: string
  presentation?: "view" | "edit"
}

type SketchJobResultState = {
  target: SketchJobResultOpen | null
  openSketchJobResult: (next: SketchJobResultOpen) => void
  closeSketchJobResult: () => void
}

export const useSketchJobResultStore = create<SketchJobResultState>((set) => ({
  target: null,
  openSketchJobResult: (next) => set({ target: next }),
  closeSketchJobResult: () => set({ target: null }),
}))
